import script from "./DescribeTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DescribeTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DescribeTemplate.vue?vue&type=style&index=0&id=ff9c8bf2&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff9c8bf2"]])

export default __exports__